<style>

.bg{
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-image: url("/i/signup-bg-wizard.jpg");
  background-size: cover;
  color: black;
  padding: 20px;
  overflow-y: scroll;
}

.margin{
  margin-top: 50px;
}

.selected{
  box-shadow: 0 0 10px #7DE0FF;
  border: 3px #7DE0FF solid;
  height: 146px;
}
.item-text-selected{
  margin-top: 6px;
}
.check{
  height: 50px;
  text-align: right;
}
.icon-check{
  font-size: 50px;
  color: #7DE0FF;
  text-shadow: 1px 1px 6px #555;
}

.search{
  position: fixed;
  top: 45px;
  left: 0;
  right: 0;
  height: 37px;
  margin: 0 20px;
  background-color: rgba(0,0,0,0.8);
}
.has-search{
  height: 50px;
}

.nothing-here{
  font-size: 24px;
  margin: 20px;
}

.buttons{
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 10px 20px;
  background-color: black;
}
.has-buttons{
  height: 100px;
}
</style>

<Header back="{back}" on:back="{ () => { pop() } }">{title}</Header>
<div class="has-header"></div>

<div class="search">
  <SearchInput bind:value="{search}" on:search="{searchNow}"></SearchInput>
</div>
<div class="has-search"></div>

<Dialog show="{freeAccountsShow}" title="" cancel="{false}" close="{false}" buttons="{ [ {text: 'Got It!', callback: 'close', disabled: false, }, ] }" on:close="{closeDialog}">
  <p>You've maxed out how many Interests you can add.  Free accounts only allow up to five to be selected.</p>
  <p>You'll have an opportunity to purchase a plan once signed in.</p>
</Dialog>

<Dialog show="{newUserShow}" title="" cancel="{false}" close="{false}" buttons="{ [ {text: 'Got It!', callback: 'close', disabled: false, }, ] }" on:close="{closeDialog}">
  <p>Search for all activities and things you're interested in.</p>
  <p>Tip: the more interests you include, the more activities and connections available!</p>
</Dialog>

<InterestCategories bind:items="{curItems}" on:selected="{selected}"></InterestCategories>

<!-- {#if curItems.length > 0}

  {#each curItems as item, index }
    <div class="item {item.s ? 'selected' : ''}" style="background-image: linear-gradient( rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4) ), url('/categories/{item.p}.jpg')" on:click="{ () => { record(index); } }">
      <div class="check">
        {#if item.s}
          <i class="icon-check"></i>
        {/if}
      </div>
      <div class="item-text {item.s ? 'item-text-selected' : ''}">{item.t}</div>
    </div>
  {/each}

{:else}
  <div class="nothing-here">Nothing here yet.  Check back later!</div>
{/if} -->

<div class="has-buttons"></div>

<div class="buttons">
  <NextButton on:click="{next}" disabled="{nextDisabled}"></NextButton>
</div>



<script>

import {push, pop, replace, location} from 'svelte-spa-router';
export let params = {};

import Header from "../../../../components/Header.svelte";
import SearchInput from "../../../../components/SearchInput.svelte";
import Dialog from "../../../../components/Dialog.svelte";
import NextButton from "../../../../components/NextButton.svelte";
import InterestCategories from "../../../../components/InterestCategories.svelte";

import tinterests from "../../../../helpers/InterestCategories.js";

import Signup from "../../../../helpers/Signup.js";
import Validate from "../../../../helpers/Validate.js";

let newUserShow = false;
let freeAccountsShow = false;

// this is what gets listed.  sub categories are assigned to this to list out
let curItems = [];
let title = "Add Interests";

let back = false;

let allowSignup = false;
let interests = [];
let interestsSaved = false;
let nextDisabled = true;


import { onMount } from "svelte";
onMount(async () => {
  
  try {
    Signup.verifyPersonalObject();
  } catch (e) {
    console.log("error:", e);
    
    if (e == "Must start from beginning") {
      document.location = "/";
    }
    
    return;
  }

  // if signup is already complete, then we push the user outta here...
  let signupComplete = Signup.getPersonalObject("signupComplete");
  if (signupComplete == true) {
    document.location = "/";
    return;
  }
  
  allowSignup = true;
  
  if ( localStorage.getItem("add-interests-new-user") == null) {
    localStorage.setItem("add-interests-new-user", 1);
  }
  newUserShow = localStorage.getItem("add-interests-new-user");

  // convert from nested version to flat version for component
  curItems = tinterests.convert();
  
  interestsSaved = Signup.getPersonalObject("interestsSaved");
  interests = Signup.getPersonalObject("interests");
  
  // associate selected interests with actual interests in the list
  for (let i in curItems) {
    if (curItems[i].h == 1 && interests.includes(curItems[i].i) == true ) {
      curItems[i].s = true;
    }
    
    // for (let j in curItems[i].subCategories) {
    //   if ( interests.includes(curItems[i].subCategories[j].i) == true ) {
    //     curItems[i].subCategories[j].s = true;
    //   }
    // }
  }
  
  if (interestsSaved == true) {
    nextDisabled = false;
  } else {
    check();
  }
  
});


function check() {
  interestsSaved = false;
  try {
    Validate.allowSignup(allowSignup);
    if (interests.length == 0) throw "Need to select at least one interest";
    nextDisabled = false;
  } catch (e) {
    nextDisabled = true;
    console.log("error:", e);
  }
}


// function setCategory() {
//   if (params.category == null || params.category == "") {
//     back = false;
//     curItems = items;
//     title = "Add Interests";
//   } else {
//     back = true;
//     for(let i in items) {
//       if (items[i].t == params.category) {
//         curItems = items[i].subCategories.sort(sortFunction);
//         title = items[i].t;
//         break;
//       }
//     }
//   }
// }


// async function record(index) {
async function selected(e) {
  
  let itemIndex = e.detail.itemIndex;
  let item = e.detail.item;
  // console.log("e.detail.itemIndex:", itemIndex);
  // console.log("e.detail.item:", item);
  
  // if selected, then save it
  if (item.s == false) {
    interests.push(item.i);
    curItems[itemIndex].s = true;
    await Signup.saveToPersonalObject("interests", interests);
    
    // once we implement paid accounts, we'll enable this code:
    // this makes it so the user can only select 5 interests
    // if (interests.length < 5) {
    //   interests.push(item.i);
    //   curItems[itemIndex].s = true;
    //   await Signup.saveToPersonalObject("interests", interests);
    // } else {
    //   freeAccountsShow = true;
    // }
  } else {
    // remove it from the interests array
    curItems[itemIndex].s = false;
    let tindex = interests.indexOf( item.i );
    if (tindex != -1) interests.splice( tindex, 1 );
    await Signup.saveToPersonalObject("interests", interests);
  }
  
  // console.log("interests:", interests);
  
  check();
    
}


let search = "";
function searchNow() {
  // console.log("search:", search);
  
  if (search == "") {
    curItems = tinterests.convert();
    return;
  }
  
  let items = tinterests.convert();
  
  // a placeholder for searched items to go into
  let searchItems = [];
  
  // loop through top level items
  let curHeader = null;
  for (let i in items) {
    
    if (items[i].h == 0) curHeader = items[i];
    if (items[i].t.toLocaleLowerCase().includes(search.toLocaleLowerCase()) == true) {
      
      // store the header so it shows up in the list
      if (curHeader != null) {
        searchItems.push(curHeader);
        curHeader = null;
      }
      searchItems.push(items[i]);
      // searchItems.push(items[i].subCategories[j]);
      // searchItems[]
    }
    
  }
  
  curItems = searchItems;
}


function closeDialog() {
  newUserShow = false;
  freeAccountsShow = false;
  localStorage.setItem("add-interests-new-user", 0);
}


async function next() {
  if (interestsSaved == false) {
    await Signup.saveToPersonalObject("interestsSaved", true);
    await Signup.saveMe("interests");
  }
  
  push("/signup/profile/personal/questions");
}


</script>